import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: rgb(241, 242, 243);
  padding: 2rem 0;
`;

export const Title = styled("h4")`
  font-size: 24px;
  text-transform: capitalize;
  color: #2A3273;
  font-family: "Gilroy Bold", sans-serif;

  @media screen and (max-width: 440px) {
    padding: 1rem 0;
  }
`;

export const SubTitle = styled.p`
  margin-bottom: 0.4rem;
  font-size: 16px;
  color: #2A3273;
  font-family: "Gilroy Semibold", sans-serif;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: #2A3273;
`;


export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #15418e;
  }
`;

export const Extra = styled("section")`
  background: rgb(241, 242, 243);
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 2rem;
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: #000000;
  font-size: 16px;
  width: 70%;
  font-family: "Gilroy Light", sans-serif;
`;

export const Contact = styled("p")`
  color: #2A3273;
  max-width: fit-content;
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.3s ease-in-out;
  font-family: "Gilroy Semibold", sans-serif;
  font-size: 18px;

  &:hover {
    color: rgb(255, 180, 171);
  }

  @media screen and (max-width: 440px) {
    font-size: 14px;
  }
`;

export const WebsiteLinks = styled("div")`
  display: flex;
  flex-direction: rwo;
  gap: 1rem;

  a {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-family: "Gilroy Medium", sans-serif;
    font-size: 16px;
    color: #2A3273;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      color: rgb(255, 130, 92);
      transform: translateY(-5px);
    }
  }

  img, svg {
    width: 30px;
    height: 30px;
  }
`;
